import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClaimTypeSelector = ({ selectedType, onTypeSelect, onNext }) => {
  const claimTypes = [
    {
      id: 'offsetting',
      title: 'Offsetting Claim',
      description: 'Neutralize residual emissions through verified carbon credit retirement',
      icon: 'Target',
      requirements: [
        'SBTi-approved net-zero target',
        'Comprehensive emission inventory',
        'Evidence of reduction efforts'
      ],
      vcmiCode: 'VCMI-OC-2024'
    },
    {
      id: 'contribution',
      title: 'Contribution Claim',
      description: 'Support climate action beyond value chain through verified credits',
      icon: 'Heart',
      requirements: [
        'Clear contribution statement',
        'No offsetting language',
        'Additionality evidence'
      ],
      vcmiCode: 'VCMI-CC-2024'
    },
    {
      id: 'inset',
      title: 'Inset Claim',
      description: 'Reduce emissions within value chain through direct interventions',
      icon: 'ArrowDownCircle',
      requirements: [
        'Value chain mapping',
        'Direct intervention evidence',
        'Scope 3 inventory alignment'
      ],
      vcmiCode: 'VCMI-IC-2024'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-card-foreground mb-2">Select Claim Type</h2>
        <p className="text-sm text-muted-foreground">
          Choose the type of VCMI-compliant claim you want to build. Each type has specific requirements and validation criteria.
        </p>
      </div>
      <div className="grid gap-4 mb-6">
        {claimTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeSelect(type?.id)}
            className={`p-4 border-2 rounded-lg text-left transition-smooth hover:border-primary/50 ${
              selectedType === type?.id
                ? 'border-primary bg-primary/5' :'border-border hover:bg-muted/50'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div className={`p-2 rounded-lg ${
                selectedType === type?.id ? 'bg-primary text-primary-foreground' : 'bg-muted'
              }`}>
                <Icon name={type?.icon} size={20} />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-2">
                  <h3 className="font-medium text-card-foreground">{type?.title}</h3>
                  <span className="text-xs font-mono bg-muted px-2 py-1 rounded">
                    {type?.vcmiCode}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground mb-3">{type?.description}</p>
                <div className="space-y-1">
                  <p className="text-xs font-medium text-card-foreground">Key Requirements:</p>
                  {type?.requirements?.map((req, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <Icon name="Check" size={12} className="text-success" />
                      <span className="text-xs text-muted-foreground">{req}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
      <div className="flex justify-end">
        <Button
          onClick={onNext}
          disabled={!selectedType}
          iconName="ArrowRight"
          iconPosition="right"
        >
          Continue to Credit Selection
        </Button>
      </div>
    </div>
  );
};

export default ClaimTypeSelector;